const initialState = {
  clients: [],
  error: null,
  loading: false,
  success: false,
};

const oauthReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CLIENT_CREATE_REQUEST":
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };
    case "CLIENT_CREATE_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
      };
    case "CLIENT_CREATE_FAIL":
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      };
    case "GET_CLIENTS":
      return {
        ...state,
        clients: action.payload,
      };
    case "CLIENT_DELETE_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        clients: state.clients.filter(
          (client) => client._id !== action.payload.id
        ),
      };
    case "CLIENT_UPDATE_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        clients: state.clients.map((client) =>
          client._id === action.payload._id ? action.payload : client
        ),
      };
    case "CLIENT_UPDATE_FAIL":
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload || "Something went wrong",
      };
    default:
      return state;
  }
};

export default oauthReducer;
